import React, { useMemo, memo } from 'react';
import { Preloader } from '../../preloader';
import { Overlay } from '../../overlay';
import { getPreloaderColor } from '../_utils/get-preloader-color';
import { BUTTON_OVERLAY_TIMEOUT } from '../constants';
export var ButtonLoader = memo(function (_a) {
    var isDarkTheme = _a.isDarkTheme, isLoading = _a.isLoading, variant = _a.variant;
    var preloaderColorCheck = useMemo(function () { return getPreloaderColor({ variant: variant, isDarkTheme: isDarkTheme }); }, [variant, isDarkTheme]);
    return (React.createElement(Overlay, { absolute: true, inherit: true, opened: isLoading, timeout: BUTTON_OVERLAY_TIMEOUT, withBorderRadius: true },
        React.createElement(Preloader, { color: preloaderColorCheck, size: "small" })));
});
